// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__wXGTH","right":"Navigation_right__Nzg+N","left":"Navigation_left__kGBZV","logo":"Navigation_logo__fgxzJ","link":"Navigation_link__6mhCS"};